import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview"

export default class RecommendBoxUI extends Plugin {
  init() {
    const editor = this.editor
    const t = editor.t

    editor.ui.componentFactory.add("recommendBox", (locale) => {
      const command = editor.commands.get("insertRecommendBox")

      const buttonView = new ButtonView(locale)

      buttonView.set({
        label: t("オススメ本"),
        withText: true,
        toolTip: true,
      })

      buttonView.bind("isOn", "isEnabled").to(command, "value", "isEnabled")

      this.listenTo(buttonView, "execute", () =>
        editor.execute("insertRecommendBox")
      )

      return buttonView
    })
  }
}
